import React, { useEffect, useState } from 'react';
import { Loader2, AlertCircle } from 'lucide-react';

export default function SSOComplete() {
    const [error, setError] = useState(null);

    useEffect(() => {
        const raw = window.location.hash ? window.location.hash.substring(1) : '';
        if (!raw) {
            setError('No authentication token received. Please try signing in again.');
            return;
        }

        // Hash format: <jwt_token>&sso_event=<event>
        const parts = raw.split('&');
        const token = parts[0];
        const params = new URLSearchParams(parts.slice(1).join('&'));
        const ssoEvent = params.get('sso_event');

        if (!token) {
            setError('No authentication token received. Please try signing in again.');
            return;
        }

        localStorage.setItem('crm_token', token);
        if (ssoEvent) {
            sessionStorage.setItem('sso_event', ssoEvent);
        }
        window.location.replace('/dashboard');
    }, []);

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#FAFAF5' }}>
                <div className="w-full max-w-sm text-center">
                    <div className="inline-flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mb-4">
                        <AlertCircle className="w-6 h-6 text-red-600" />
                    </div>
                    <h2 className="text-lg font-semibold text-stone-900 mb-2" style={{ fontFamily: 'Manrope, system-ui, sans-serif' }}>
                        Sign-in failed
                    </h2>
                    <p className="text-sm text-stone-500 mb-6">{error}</p>
                    <a
                        href="/login"
                        className="inline-block px-6 py-2.5 bg-stone-900 text-white text-sm font-medium rounded-lg hover:bg-stone-800 transition-colors"
                    >
                        Back to login
                    </a>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#FAFAF5' }}>
            <div className="text-center">
                <Loader2 className="w-8 h-8 text-stone-400 animate-spin mx-auto mb-3" />
                <p className="text-sm text-stone-500">Completing sign-in...</p>
            </div>
        </div>
    );
}
